import React from 'react';
import './hero.css'
import heropic from '../../assets/hero-background.png'
import Textbtn from '../textbtn/textbtn';
import arrow from '../../assets/arrow-hero.svg'
import search from '../../assets/search.svg'

const Hero = () => {
    return (
        <div className='hero-container'>
          <img className='heroimg'  src={heropic} alt='/' />
            <div className='btn-container'>
                <h3 className='title'>Search for available Properties</h3>
                <div className='btn-text-container'>
                <Textbtn text='Location' s2='btn' icon={arrow}/>
                <Textbtn text='Property Type' s2='btn' icon={arrow}/>
                <Textbtn text='Budget' s2='btn' icon={arrow}/>
                <Textbtn text='Search Now' s2='btn2' icon={search}/>
                </div>
            </div>
        </div>
    );
}
 
export default Hero;